<template>
  <div id="body-fat-index">
    Ciężar maksymalny
    <form @submit.prevent="calculate">
      <div>
        <input type="number" min="0" v-model="weight" placeholder="Podniesiony ciężar (kg)">
      </div>
      <div>
        <input type="number" min="0" v-model="reps" placeholder="Powtórzenia">
      </div>
      <input type="submit" value="Oblicz">
    </form>
    <div v-if="displayFields">
      <div class="maximum-weight">
        Wskaźnik one-rep max to:
        <div>{{this.result.toFixed(0)}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaximumWeight',
  methods: {
    calculate: function() {
      this.result = Math.round(this.weight * (1 + (this.reps / 30 ) ) );
      this.displayFields = true;
    },
  },
  data() {
    return {
      weight: null,
      reps: null,
      result: 0,
      displayFields: false
    }
  }
}
</script>

